import axios from 'axios'
import store from '../store/store'
import router from '../router/index'
import axiosRetry from 'axios-retry'

const http = axios.create({
    baseURL: '/api',
    headers: { 'Content-Type': 'application/json' }
})

axiosRetry(http, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

http.interceptors.request.use(
    function (config) {
        const token = store.state.auth.token
        if (token) config.headers.Authorization = `Bearer ${token}`
        return config
    },
    function (error) {
        if (error.status === 401) {
            store.dispatch('auth/logout')
            router.push('/login')
        }
        return Promise.reject(error)
    }
)

export default http
